//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Game = require('@/tbs/model/to/Game')
const Player = require('@/tbs/model/to/Player')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Match class works as the organization translator.
 */
const tbs_model_to_Team = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Game, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Team.prototype = {
    'team-number': '球队数',
    'team-empty-hint': '赛事还没有任何球队，立即新建',
    'team-count-num': '已有球队$num支',
    'team-total-num': '总$num支',
    'team-name-required': '请填写球队名称',
    'team-name-label': '球队名称',
    'team-name-placeholder': '球队名称',
    'team-logo-label': '球队LOGO',
    'team-logo-placeholder': '建议使用PNG格式，背景透明图片，图片大小400X400 PX',
    'delete-team': '删除球队',
    'delete-team-confirm-message': '确认删除该球队，无法进行还原',
    'all-status': '全部状态',
    'all-divisions': '全部小组',
    'unassigned-division': '未分配组',
    'team-list': '球队列表',
    'team-space': '球队空间',
    'player-empty-hint': '球队中暂无球员，新建球员',
    'batch-create': '批量新建',
    'groups': '分组',
    'group-seq-label': '# $num',
    'group-team-num-rate': '本组球队 $num/$total',
    'group-count-num': '已完成$num组',
    'group-total-num': '总$num组',
    'reset-all-group': '重置分组球队',
    'reset-all-group-confirm-message': '是否需要重置所有分组中的球队？',
    'reset-group': '重置该组球队',
    'reset-group-confirm-message': '是否需要重置该组中的所有球队？',
    'shift-team': '移出小组球队',
    'shift-team-confirm-message': '是否需要从当前小组移出该球队且清空其相关的小组赛程？',
    'group-team-drag-hint': '手动可以拖拽球队顺序',
    'unassigned-group-team': '未分配球队',
    'group-team-empty-hint': '小组中暂无球队，导入球队',
}

//--------------------------------------------------
// extends the Game
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Team, Game);
ClassFunc.extend(tbs_model_to_Team, Player);

module.exports = tbs_model_to_Team